export const UiBreakpoints = {
	xs: 375,
	sm: 640,
	md: 768,
	lg: 1024,
	xl: 1280,
	"2xl": 1535,
};
